import { IReward } from './IReward';
import { Reward } from './Reward';
import AchTransactionTypes from '../AchTransactionTypes';

export class PerAchTrxTypeFeeReductionReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.PerAchTrxTypeFeeReductionReward';

	public static readonly NAME: string = 'Per ACH Transaction Type Fee Reduction';

	achTransactionType: string = AchTransactionTypes.ACH_DEBIT.value;

	perAchTrxTypeFeeReductionAmount: number = 0;

	minimumTrxAmount: number = 0;

	feeReductionCapAmount: number = 0;

	constructor(reward?: IReward) {
	  super(PerAchTrxTypeFeeReductionReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.achTransactionType = (reward as any).achTransactionType;
	    this.perAchTrxTypeFeeReductionAmount = (reward as any).perAchTrxTypeFeeReductionAmount;
	    this.minimumTrxAmount = (reward as any).minimumTrxAmount;
	    this.feeReductionCapAmount = (reward as any).feeReductionCapAmount;
	  }
	}

	getDescription(): string {
	  let feeReductionCapAmountDesc = '';
	  if (this.feeReductionCapAmount) {
	    feeReductionCapAmountDesc = `$${this.feeReductionCapAmount} reduction cap`;
	  }
	  return `$${this.perAchTrxTypeFeeReductionAmount} fee reduction per ${this.achTransactionType} transaction $${this.minimumTrxAmount} or over. ${feeReductionCapAmountDesc}`;
	}

	clone(): IReward {
	  const clone = new PerAchTrxTypeFeeReductionReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default PerAchTrxTypeFeeReductionReward;
